import { baseDomain } from '@/common/config'
import { service } from '@/utils/request.js'

const Api = {
  Voice_List: baseDomain + '/voice/page', // 音色列表
  Voice_Detail: baseDomain + '/voice/', // 音色详情
  Voice_Add: baseDomain + '/voice/create', // 音色添加
  Voice_Delete: baseDomain + '/voice/', // 音色删除
  Voice_Edit: baseDomain + '/voice/update', // 音色编辑
  Voice_Clone: baseDomain + '/voice/clone/task', // 音色复刻
  Voice_Clone_Progress: baseDomain + '/voice/clone/task/', // 音色复刻进度
  Voice_Clone_Save: baseDomain + '/voice/clone/task/', // 音色保存
}

export const reqVoiceList = (params) => {
  return service({
    url: Api.Voice_List,
    method: 'POST',
    data: params
  })
}

export const reqVoiceDetail = (id) => {
  return service({
    url: Api.Voice_Detail + id,
    method: 'GET',
  })
}

export const reqVoiceAdd = (params) => {
  return service({
    url: Api.Voice_Add,
    method: 'POST',
    data: params
  })
}
export const reqVoiceEdit = (params) => {
  return service({
    url: Api.Voice_Edit,
    method: 'PUT',
    data: params
  })
}
export const reqVoiceDelete = (id) => {
  return service({
    url: Api.Voice_Delete + id,
    method: 'DELETE',
  })
}
export const reqVoiceClone = (params) => {
  return service({
    url: Api.Voice_Clone,
    method: 'POST',
    data: params
  })
}
export const reqVoiceCloneProgress = (id) => {
  return service({
    url: Api.Voice_Clone_Progress + id,
    method: 'GET',
  })
}

export const reqVoiceSave = (id, params) => {
  return service({
    url: Api.Voice_Clone_Save + id + '/save',
    method: 'POST',
    data: params
  })
}
